var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"partial partial--checkins"},[_c('card',[_c('list-profiles',{attrs:{"profiles":_vm.checkins}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }